module.exports = "/images/arrow-left-green.svg?17efdec447240aa2a872bb69a163e46d";